/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import NewDoctorDataContent from "components/content/NewDoctorContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { UserRolesEnum } from "medicalsystem-shared";

/**
 * Properties for NewDoctorPage component.
 * 
 * @interface Props
 * @property {boolean} isDoctor - Whether creating a doctor or nurse profile
 * @property {boolean} [isHeadNurse=false] - Whether creating head nurse role
 */
interface Props {
  isDoctor: boolean;
  isHeadNurse?: boolean;
}

/**
 * New doctor or nurse registration page.
 * Provides unified form for creating medical provider profiles.
 * 
 * Features:
 * - Personal and professional information entry
 * - Specialty and credentials capture
 * - License and certification tracking
 * - Contact information
 * - Availability and schedule setup
 * - User account creation
 * - Role assignment (doctor, nurse, head nurse)
 * - Form validation with error handling
 * - Integration with provider management system
 * 
 * The component adapts the form based on role:
 * - Doctor: Full provider privileges and specialties
 * - Nurse: Nursing-specific fields and permissions
 * - Head Nurse: Additional administrative capabilities
 * 
 * @param {Props} props - Component properties
 * @returns {JSX.Element} New doctor/nurse registration page
 */
const NewDoctorPage = ({ isDoctor, isHeadNurse = false }: Props) => {
  return (
    <DefaultDashboardLayout>
      <NewDoctorDataContent isDoctor={isDoctor} isHeadNurse={isHeadNurse} />
    </DefaultDashboardLayout>
  );
};

export default NewDoctorPage;

